import {View} from './view';

declare const grecaptcha: any;

export class RecaptchaV3View extends View {

    tokenV3: any;

    render = (isFormRecaptchaEnabled: boolean) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.text = `${this.onRecaptchaReady(isFormRecaptchaEnabled)}`;
        script.onload = () => Promise.resolve();
        document.body.appendChild(script);
    }

    onRecaptchaReady = (isFormRecaptchaEnabled: boolean) => {
        grecaptcha.ready(() => {
            this.fetchToken();
            this.triggerRefreshTokenCron();
            if (!isFormRecaptchaEnabled) {
                this.hideRecaptchaBadge();
            }
        });
    }

    fetchToken = () => {
        grecaptcha
            .execute(`${process.env.RECAPTCHA_V3_SITE_KEY}`, { action: 'dfform' })
            .then((token: any) => {
                this.tokenV3 = token;
            });
    }

    triggerRefreshTokenCron = () => {
        setInterval(() => {
            this.fetchToken();
        }, 120000);
    }

    hideRecaptchaBadge = () => {
        const recaptchaBadge = this.getHtmlElement('.grecaptcha-badge');
        if (recaptchaBadge) {
            recaptchaBadge.style.visibility = 'hidden';
        }
    }
    
    getGrecaptchaInstance = () => {
        return grecaptcha;
    }

}
